export default class InputGetCategorieList
{
  constructor(pageSize, pageNumber, searchText, orderBy, propertyName, type) 
  {
    this.pageSize = pageSize;
    this.pageNumber = pageNumber;
    this.searchText = searchText;
    this.orderBy = orderBy;
    this.propertyName = propertyName;
    this.type = type;
  }    
}